module.exports = __webpack_public_path__ + "static/media/react.71565432.gif";